import Rest from '../services/rest'
import {store} from '../store/store'

/**
 * @typedef {ArtistService}
 */
export default class ArtistService{

    constructor() {
        this.resource = "/artist"

        this.http = Rest.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    get_all(item){
        var parameters = new URLSearchParams(item);
       
        parameters = parameters.toString();
        if(parameters){
            parameters = "?"+parameters;
        }
        return this.http.get(`/all${parameters}`);
    }

    get_one(product_id){
        return this.http.get(`/${product_id}`)    
    }

    releaseVideo(artist_id){
        return this.http.post(`/release_video`,{artist_id:artist_id});
    }


}